// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ct-0";
export var fileCarousel = "_ct-2";
export var removeFileButton = "_ct-1";